import { Smartphone, Clock } from "lucide-react";
import ViewMgtDevicePanel from "../ViewMgtDevicePanel";
import { getPastRelativeTime } from "functions/deviceStatusUtils";

export default function ViewMgtDeviceStatusRemotes({ device }: { deviceId?: string | null | undefined, device?: any | undefined | null }) {
  
  const remotes = device?.ConfigurationStatusLog?.configuration?.RemotesConfiguration?.RemoteConfigurations ?? [];
  const timestamp = device?.ConfigurationStatusLog?.logTimestamp;

  console.log(device);

  return (
    <ViewMgtDevicePanel title="Remotes" icon={<Smartphone size={16} />}>
      <div className="p-3 space-y-2">
        {remotes.filter((x: any) => !x.IsPanic).map((remote: any, index: number) => (
          <div key={index} className="flex justify-between items-center text-sm">
            <div className="flex items-center gap-1">
              <span className="font-medium font-bold text-slate-700">{remote?.RemoteSerialNumber}</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="font-medium font-bold text-slate-700">({(((device.Remotes ?? {})[remote?.RemoteSerialNumber]?.remoteBatteryVoltageMilli ?? (device[`Remotes.${remote?.RemoteSerialNumber}`] ?? {})?.remoteBatteryVoltageMilli ?? 0) / 1000.0).toFixed(2)}V)</span>
            </div>
            <div className="text-xs text-slate-500 flex items-center gap-1">
              { timestamp && timestamp !== "-" ? <><Clock size={14} />{getPastRelativeTime(timestamp)}</> : "-" }
            </div>
          </div>
        ))}
      </div>
    </ViewMgtDevicePanel>
  );
}
